import { useRef } from 'react'
import { useDispatch } from 'react-redux'
import { Icon, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { Box } from '@mui/system'

const SearchBar = ({
  actionToDispatch,
  searchPlaceholder,
  customStyles,
  actionProps,
  ...props
}) => {
  const dispatch = useDispatch()
  const searchInput = useRef('')
  const timeoutId = useRef()

  const searchOnBlur = () => {
    clearTimeout(timeoutId.current);

    timeoutId.current = setTimeout(() => {
      dispatch(actionToDispatch({ queries: `${searchInput.current.value || ''}`, actionProps }))
    }, 600);
  }

  return (
    <Box sx={[styles.root, customStyles]} {...props}>
      <TextField
        fullWidth
        inputRef={searchInput}
        onChange={searchOnBlur}
        sx={styles.root.inputField}
        placeholder={searchPlaceholder}
        name='pageSearchBar'
        id='pageSearchBar'
      />

      <Box sx={styles.root.iconButton} onClick={searchOnBlur}>
        <Icon component={SearchIcon} />
      </Box>
    </Box>
  )
}

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    maxHeight: '40px',
    marginBottom: '20px',
    minWidth: { xs: '250px', sm: '350px', md: '550px' },
    '& .MuiInputLabel-outlined.MuiInputLabel-marginDense': {
      transform: 'translate(14px,12px) scale(1)',
    },
    '& .MuiFormControl-marginDense': {
      paddingRight: '0',
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#fafbfc',
      borderRadius: '10px',

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.main',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'solid 2px #e2e8ee',
      transition: 'all 0.3s ease-in-out',
    },
    '& .MuiOutlinedInput-inputMarginDense': {
      padding: '12px',
    },
    '& .MuiAlert-root': {
      width: '100%',
    },

    inputField: {
      transition: 'all 0.5s ease',
      height: { xs: '20px', sm: '40px' },
      input: {
        textTransform: 'capitalize',
        padding: '0',
        paddingLeft: '40px',
        width: '100%',
        height: { xs: '30px', sm: '40px' },
        '&::placeholder': {
          textOverflow: 'ellipsis',
        },
      },
      '&:hover': {
        borderColor: 'primary.main',
      },
      fieldset: {
        border: 0,
        borderColor: 'unset',
      },
    },

    iconButton: {
      display: 'flex',
      position: 'absolute',
      left: '0',
      top: { xs: '5px', sm: 'unset' },
      width: '40px',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      zIndex: 2,
      svg: {
        fontSize: { xs: '20px', sm: '28px' },
        color: 'text.hint',
        mt: { xs: '0px' },
      },
    },
  },
}

export default SearchBar
